import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-71ac73e8")

_pushScopeId("data-v-71ac73e8")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Documenti")
const _hoisted_2 = {
  key: 0,
  class: "loading_spinner"
}
const _hoisted_3 = {
  key: 1,
  class: "page_content"
}
const _hoisted_4 = { class: "documenti_switcher_container" }
const _hoisted_5 = { class: "documenti_switcher" }
const _hoisted_6 = { class: "search_container" }
const _hoisted_7 = {
  key: 0,
  class: "no_documents_container_detail"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "no_documents" }, "Nessun documento da visualizzare", -1)
const _hoisted_9 = { class: "documenti_container" }
const _hoisted_10 = { class: "document_info" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = {
  key: 0,
  class: "icon"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.loadDocuments()))
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "start",
                        icon: $setup.refresh,
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          ($setup.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode(_component_ion_spinner, {
                  name: "crescent",
                  color: "dark"
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.categorieDocumenti, (category, index) => {
                      return (_openBlock(), _createBlock("div", {
                        key: index,
                        class: ["type", [$setup.selectedDocumentType == category.documenti_dipendenti_categoria_id ? 'active' : '']],
                        onClick: ($event: any) => ($setup.setActiveDocuments(`${category.documenti_dipendenti_categoria_id}`))
                      }, _toDisplayString($setup.setSwitchLabel(category.documenti_dipendenti_categoria_value)), 11, ["onClick"]))
                    }), 128))
                  ])
                ]),
                _createVNode("div", _hoisted_6, [
                  _createVNode(_component_ion_input, {
                    type: "text",
                    "clear-input": "",
                    modelValue: $setup.searchQuery,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.searchQuery = $event)),
                    placeholder: "Cerca documento",
                    class: "search_documents"
                  }, null, 8, ["modelValue"])
                ]),
                ($setup.documentsToShow.length == 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_7, [
                      _hoisted_8
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_9, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.documentsToShow, (documento) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "documento",
                      key: documento.documenti_dipendenti_id,
                      onClick: ($event: any) => ($setup.openDetail(documento, documento.documenti_dipendenti_id))
                    }, [
                      _createVNode("div", _hoisted_10, [
                        _createVNode("div", _hoisted_11, _toDisplayString(documento.documenti_dipendenti_categoria != 3
                                        ? documento.documenti_dipendenti_nome_documento
                                        : $setup.dateFormat(documento.documenti_dipendenti_data_documento) + " - " + documento.documenti_dipendenti_titolo), 1),
                        (documento.documenti_dipendenti_categoria != 3)
                          ? (_openBlock(), _createBlock("div", {
                              key: 0,
                              class: ["date", { date_expired: $setup.documentoScaduto(documento) }]
                            }, " Data scadenza: " + _toDisplayString($setup.dateFormat(documento.documenti_dipendenti_data_scadenza)), 3))
                          : _createCommentVNode("", true)
                      ]),
                      (documento.documenti_dipendenti_file)
                        ? (_openBlock(), _createBlock("div", _hoisted_12, [
                            _createVNode(_component_ion_icon, {
                              icon: $setup.attach,
                              class: "attachment"
                            }, null, 8, ["icon"])
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, ["onClick"]))
                  }), 128))
                ])
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})